export default __webpack_public_path__ + "static/media/notificationWhite.797cfc35.svg";